import { LeadOrigin } from "@justhome/api-core";
import { useState } from "react";

const utmMapping = {
  utm_source: "source",
  utm_campaign: "campaign",
  utm_medium: "medium",
  utm_term: "term",
  utm_content: "content",
};

const getQueryParams = (url: string): LeadOrigin => {
  const queryParams: LeadOrigin = {};
  const queryString = url.split("?")[1];
  if (queryString) {
    const params = queryString.split("&");
    params.forEach((param) => {
      const [key, value] = param.split("=");
      if (key && value && Object.keys(utmMapping).includes(key)) {
        const utmKey = utmMapping[key as keyof typeof utmMapping];
        queryParams[utmKey as keyof LeadOrigin] = decodeURIComponent(value);
      }
    });
  }
  return queryParams;
};

const useUtmParams = (): LeadOrigin => {
  const [utmParams] = useState(() => getQueryParams(window.location.href));

  return utmParams;
};

export default useUtmParams;
